import * as React from "react";

const SvgIcnUser = (props: React.SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10 3.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5ZM6.5 6a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0Zm3.5 5.5A5.5 5.5 0 0 0 4.5 17a.5.5 0 0 1-1 0 6.5 6.5 0 1 1 13 0 .5.5 0 0 1-1 0 5.5 5.5 0 0 0-5.5-5.5Z"
            fill="currentColor"
            stroke="none"
            strokeWidth={1}
        />
    </svg>
);

export default SvgIcnUser;
